import { render, staticRenderFns } from "./Workview.vue?vue&type=template&id=7a4c567e&"
import script from "./Workview.vue?vue&type=script&lang=ts&"
export * from "./Workview.vue?vue&type=script&lang=ts&"
import style0 from "./Workview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports